// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'default-passive-events';
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from './http';
import store from './store';
import Cookies from 'js-cookie';
import 'jquery';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import ga from './utils/google-analyze.js';
// 引入swiper样式
import 'swiper/css/swiper.css';
import vueEsign from 'vue-esign';
import Vue18n from 'vue-i18n';

Vue.config.productionTip = false;

Vue.use(vueEsign);
Vue.use(Vue18n);
Vue.use(ElementUI);

window.eventBus = new Vue();

Vue.prototype.$axios = axios;
Vue.prototype.$cookies = Cookies;
Vue.prototype.$sessionStorage = sessionStorage;
Vue.prototype.$localStorage = localStorage;
Vue.prototype.ga = ga;

//多语言
const i18n = new Vue18n({
  locale: sessionStorage.getItem('language') || 'en',
  fallbackLocale: 'en',
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'en': require('./lang/en'),   // 英文语言包
    'zh-CN': require('./lang/zh-CN'),   // 中文语言包
    'zh-TW': require('./lang/zh-TW'),    //中文繁体
  },
});

new Vue({
  i18n,
  router,
  store,
  Cookies,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js